import React from "react";
import { Accordion } from "react-bootstrap";

const DroneFaq = () => {
  // return (
  //   <div className="background_light">
  //     <div className="container">
  //       <h4 className="fs_21 ff_inter fw-bold color_darkgray ">
  //         Drone Training FAQs
  //       </h4>

  //       <div className="dronelab_accordion">
  //         <Accordion className="mt-2 " defaultActiveKey="0">
  //           <Accordion.Item className="" eventKey="0">
  //             <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
  //               <li className=" list_style color_blue fs_21"></li>
  //               <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
  //                 What is a Remote Pilot License?
  //               </p>
  //             </Accordion.Header>
  //             <Accordion.Body className="fs_17 ff_inter color_darkgray">
  //               A Remote Pilot License is equivalent to a driver's license for a
  //               car. A license is required to fly a drone for commercial
  //               purposes in India. Flying commercially without a Remote Pilot
  //               License would be termed illegal.
  //             </Accordion.Body>
  //           </Accordion.Item>
  //           <Accordion.Item className="" eventKey="1">
  //             <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
  //               <li className=" list_style color_blue fs_21"></li>
  //               <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
  //                 Why do I need drone flying training?
  //               </p>
  //             </Accordion.Header>
  //             <Accordion.Body className="fs_17 ff_inter color_darkgray">
  //               As a professional flier, drone pilot training not only helps you
  //               acquire the necessary drone flying skills but is also a
  //               mandatory requirement to get a remote pilot license.
  //             </Accordion.Body>
  //           </Accordion.Item>
  //           <Accordion.Item className="" eventKey="2">
  //             <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
  //               <li className=" list_style color_blue fs_21"></li>
  //               <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
  //                 What is the cost of drone pilot training?
  //               </p>
  //             </Accordion.Header>
  //             <Accordion.Body className="fs_17 ff_inter color_darkgray">
  //               The cost of drone training varies as per the category of the
  //               drone. It also varies on the duration of the training and the
  //               institute you are enrolled in.
  //             </Accordion.Body>
  //           </Accordion.Item>
  //           <Accordion.Item className="" eventKey="3">
  //             <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
  //               <li className=" list_style color_blue fs_21"></li>
  //               <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
  //                 What are the types of Drone Remote Pilot Licences in India?
  //               </p>
  //             </Accordion.Header>
  //             <Accordion.Body className="fs_17 ff_inter color_darkgray">
  //               Based on the category of drone, Remote Pilot Licenses have been
  //               divided into three categories:
  //               <ul className="ms-0 ps-0 mt-2">
  //                 <li>
  //                   <strong> CAT1 Remote Pilot License (RePL) Basic - </strong>{" "}
  //                   up to Small Category, for operation only in visual line of
  //                   sight in Green Zones up to 400ft altitude.
  //                 </li>
  //                 <li className="mt-1">
  //                   <strong> CAT2 Remote Pilot License (RePL) Special -</strong>{" "}
  //                   up to Medium Category, for operation in all zones beyond
  //                   visual line of sight and beyond 400ft altitude
  //                 </li>
  //                 <li className="mt-1">
  //                   <strong> CAT3 Remote Pilot License (RePL) Advance -</strong>{" "}
  //                   up to Large Category, for operation in all zones beyond
  //                   visual line of sight and beyond 400ft altitude.
  //                 </li>
  //               </ul>
  //             </Accordion.Body>
  //           </Accordion.Item>
  //           <Accordion.Item className="" eventKey="4">
  //             <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
  //               <li className=" list_style color_blue fs_21"></li>
  //               <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
  //                 Can I fly a small drone with a CAT1 Remote Pilot Basic
  //                 license?
  //               </p>
  //             </Accordion.Header>
  //             <Accordion.Body className="fs_17 ff_inter color_darkgray">
  //               No, you should have a CAT2 Remote Pilot Special License to fly a
  //               small-category drone
  //             </Accordion.Body>
  //           </Accordion.Item>
  //           <Accordion.Item className="" eventKey="5">
  //             <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
  //               <li className=" list_style color_blue fs_21"></li>
  //               <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
  //                 Can I fly Beyond the Visual Line of Sight with a Remote Pilot
  //                 License?
  //               </p>
  //             </Accordion.Header>
  //             <Accordion.Body className="fs_17 ff_inter color_darkgray">
  //               You must possess a CAT2 or CAT3 license along with the required
  //               permission from DGCA to be able to fly Beyond the Visual Line of
  //               Sight.
  //             </Accordion.Body>
  //           </Accordion.Item>
  //           <Accordion.Item className="" eventKey="6">
  //             <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
  //               <li className=" list_style color_blue fs_21"></li>
  //               <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
  //                 How many days of training is needed for a Remote Pilot
  //                 License?
  //               </p>
  //             </Accordion.Header>
  //             <Accordion.Body className="fs_17 ff_inter color_darkgray">
  //               It depends upon the type of remote pilot course you are enrolled
  //               in and the type of aircraft (airplane, rotorcraft, or hybrid)
  //               you are trained in.
  //             </Accordion.Body>
  //           </Accordion.Item>
  //           <Accordion.Item className="" eventKey="7">
  //             <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
  //               <li className=" list_style color_blue fs_21"></li>
  //               <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
  //                 I am a student, is there a separate pilot license for me?
  //               </p>
  //             </Accordion.Header>
  //             <Accordion.Body className="fs_17 ff_inter color_darkgray">
  //               No, there are no separate provisions as per the rules. The
  //               Student Remote Pilot License has the same requirements as that
  //               of a Remote Pilot License.
  //             </Accordion.Body>
  //           </Accordion.Item>
  //           <Accordion.Item className="" eventKey="8">
  //             <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
  //               <li className=" list_style color_blue fs_21"></li>
  //               <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
  //                 Do I still need training if I already know how to fly a drone?
  //               </p>
  //             </Accordion.Header>
  //             <Accordion.Body className="fs_17 ff_inter color_darkgray">
  //               Training helps learn the desired skills and is also the only
  //               route to get a Remote Pilot License for commercial and
  //               professional flying.
  //             </Accordion.Body>
  //           </Accordion.Item>
  //           <Accordion.Item className="" eventKey="9">
  //             <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
  //               <li className=" list_style color_blue fs_21"></li>
  //               <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
  //                 Do I need a remote pilot license to fly a micro drone?
  //               </p>
  //             </Accordion.Header>
  //             <Accordion.Body className="fs_17 ff_inter color_darkgray">
  //               You need a license if you are flying a micro drone for
  //               commercial purposes. However, you do not need a license if you
  //               are flying a micro drone for non-commercial use. Nano-drone
  //               flying is also exempted from licensing.
  //             </Accordion.Body>
  //           </Accordion.Item>
  //           <Accordion.Item className="" eventKey="10">
  //             <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
  //               <li className=" list_style color_blue fs_21"></li>
  //               <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
  //                 How long will my drone license be valid?
  //               </p>
  //             </Accordion.Header>
  //             <Accordion.Body className="fs_17 ff_inter color_darkgray">
  //               Remote pilot licenses come with a validity of 10 years unless
  //               suspended or canceled. Also, a remote pilot license is valid
  //               only if it is enlisted on the Digital Sky Platform.
  //             </Accordion.Body>
  //           </Accordion.Item>
  //           <Accordion.Item className="" eventKey="11">
  //             <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
  //               <li className=" list_style color_blue fs_21"></li>
  //               <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
  //                 How can I renew my remote pilot license?
  //               </p>
  //             </Accordion.Header>
  //             <Accordion.Body className="fs_17 ff_inter color_darkgray">
  //               The remote pilot license can be renewed by any authorized Remote
  //               Pilot Training Organization (RPTO) for a maximum period of 10
  //               years. You may be required to undergo refresher courses
  //               specified on the Digital Sky Platform.
  //             </Accordion.Body>
  //           </Accordion.Item>
  //           <Accordion.Item className="" eventKey="12">
  //             <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
  //               <li className=" list_style color_blue fs_21"></li>
  //               <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
  //                 What is the eligibility criteria to apply for a remote pilot
  //                 license?
  //               </p>
  //             </Accordion.Header>
  //             <Accordion.Body className="fs_17 ff_inter color_darkgray">
  //               All the conditions must be fulfilled - your age must be 18-65;
  //               you should have passed class 10th or equivalent examination from
  //               a recognized board; you should have completed the training
  //               prescribed for the applicable class of remote pilot license from
  //               an authorized RPTO.
  //             </Accordion.Body>
  //           </Accordion.Item>
  //           <Accordion.Item className="" eventKey="13">
  //             <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
  //               <li className=" list_style color_blue fs_21"></li>
  //               <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
  //                 Is becoming a drone pilot a good career choice in India?
  //               </p>
  //             </Accordion.Header>
  //             <Accordion.Body className="fs_17 ff_inter color_darkgray">
  //               The Indian government is actively promoting and facilitating the
  //               growth of the drone industry. With this growth, the demand for
  //               drone pilots is set to grow significantly. It is a good career
  //               option as the industry has already started taking shape.
  //             </Accordion.Body>
  //           </Accordion.Item>
  //         </Accordion>
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default DroneFaq;
